import { useState } from "react";
import { Box, Button, CircularProgress, TextField, Typography } from "@mui/material";
import { LinkifiedText, primaryButtonSx } from "./approvalUi";

// What a Script Approval version is: plain text. Plugged into the shared
// ApprovalReviewPanel through approvalKinds.js.

export const ScriptView = ({ version }) => (
  <Typography sx={{ fontSize: 14, lineHeight: 1.65, whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
    <LinkifiedText text={version.body} />
  </Typography>
);

// Edits always start from the latest version and remember which one — the
// backend 409s the save if someone else saved in between.
export const ScriptEditor = ({ item, isSaving, onCancel, onSave }) => {
  const [baseVersion] = useState(item.currentVersion);
  const [body, setBody] = useState(item.body);
  return (
    <Box>
      <TextField
        fullWidth
        multiline
        minRows={10}
        autoFocus
        value={body}
        onChange={(e) => setBody(e.target.value)}
        inputProps={{ maxLength: 20000 }}
        placeholder="Write the script here…"
        sx={{ "& .MuiInputBase-root": { bgcolor: "#FAFAFA", borderRadius: "12px", fontSize: 14, lineHeight: 1.6 } }}
      />
      <Typography sx={{ fontSize: 12, color: "#6B7280", mt: 0.75 }}>
        Saving creates version {baseVersion + 1}
        {baseVersion > 0 && " and asks the brand to approve again"}.
      </Typography>
      <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end", mt: 1 }}>
        <Button onClick={onCancel} sx={{ textTransform: "none" }}>Cancel</Button>
        <Button
          variant="contained"
          disabled={!body.trim() || body === item.body || isSaving}
          onClick={() => onSave({ body, baseVersion })}
          sx={primaryButtonSx}
        >
          {isSaving ? <CircularProgress size={18} color="inherit" /> : "Save new version"}
        </Button>
      </Box>
    </Box>
  );
};
